import React, { useEffect, useRef } from 'react'
import ReactDOM from 'react-dom'
import useFloatingPosition from './useFloatingPosition'
import { getPortalContainer } from './portal'
import { MENTION_PAGE_MIN_CHARS } from './api'
import useStyles from './styles'


// Popup list for the "/" command menu and @mentions
const SuggestionMenu = (props) => {
  const {
    editor,
    kind,
    suggestion,
    selectedIndex,
    setSelectedIndex
  } = props
  const localClasses = useStyles()
  const menuRef = useRef(null)
  const items = suggestion ? suggestion.items : []

  useFloatingPosition(
    menuRef,
    () => suggestion && suggestion.clientRect && {
      getBoundingClientRect: () => suggestion.clientRect() || new DOMRect(),
      contextElement: editor.view.dom
    },
    { open: !!suggestion },
    [suggestion]
  )

  useEffect(() => {
    const menu = menuRef.current
    const active = menu && menu.querySelector('[data-active="true"]')
    if (active) {
      active.scrollIntoView({ block: 'nearest' })
    }
  }, [selectedIndex, suggestion])

  if (!suggestion) {
    return null
  }

  const isMention = kind === 'mention'
  const searching = suggestion.loading || suggestion.pagesPending
  const showPageHint = isMention && suggestion.query.trim().length < MENTION_PAGE_MIN_CHARS

  return ReactDOM.createPortal(
    <div className={`${localClasses.popover} ${localClasses.slashMenu}`} ref={menuRef}>
      {
        items.length === 0 &&
        <div className={localClasses.menuEmpty}>
          {searching ? 'Searching…' : (isMention ? 'No people or pages found' : 'No results')}
        </div>
      }
      {
        items.map((item, index) => (
          <React.Fragment key={item.id}>
            {
              (index === 0 || items[index - 1].group !== item.group) &&
              <div className={localClasses.menuLabel}>{item.group}</div>
            }
            <div
              className={localClasses.slashItem}
              data-active={index === selectedIndex}
              onMouseEnter={() => setSelectedIndex(index)}
              onMouseDown={(event) => {
                event.preventDefault()
                suggestion.command(item)
              }}
            >
              {
                item.avatar ?
                <img className={`${localClasses.slashIcon} ${isMention ? 'small round' : ''}`} src={item.avatar} alt='' /> :
                <div className={`${localClasses.slashIcon} ${isMention ? 'small' : ''} ${item.kind === 'user' ? 'round' : ''}`}>
                  {item.icon}
                </div>
              }
              <div className={localClasses.slashText}>
                <div className={localClasses.slashTitle}>{item.title}</div>
                {
                  item.description &&
                  <div className={localClasses.slashDescription}>{item.description}</div>
                }
              </div>
            </div>
          </React.Fragment>
        ))
      }
      {
        items.length > 0 && suggestion.pagesPending &&
        <div className={localClasses.menuHint}>Searching advices and legal changes…</div>
      }
      {
        showPageHint &&
        <div className={localClasses.menuHint}>
          Type {MENTION_PAGE_MIN_CHARS}+ characters to search advices and legal changes
        </div>
      }
    </div>,
    getPortalContainer(editor)
  )
}

export default SuggestionMenu
